import { Component, ViewContainerRef, OnInit, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { ProgramService } from './client-core/services/program.service';
import { Subscription } from 'rxjs';
import { ProgramId } from './client-core/dtos/programs.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from './client-core/api.service';
import { NotificationService } from './shared/utils/notification.service';
import { AuthService } from './+auth/auth.service';
import { AnalyticsService } from './client-core/services/analytics-service';
import { environment } from '../environments/environment';
import { CampaignService } from './client-core/services';
import { LayoutService } from './shared/layout/layout.service';

declare var ga: Function;
declare var location: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
    static apiunauthorizederror: Subscription;
    public title = 'app works!';
    private programApprovedSubscription: Subscription;
    private programSubmittedSubscription: Subscription;

    public constructor(
        private viewContainerRef: ViewContainerRef,
        private programService: ProgramService,
        private router: Router,
        private apiservice: ApiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private vcr: ViewContainerRef,
        private campaignService: CampaignService,
        private layoutService: LayoutService,
        private elementRef: ElementRef
    ) {
        // this.vcr.element.nativeElement.parentElement.classList.add('ferraraclass');
        if (location.hostname.toLocaleLowerCase().indexOf('ferrara') > -1) {
            this.vcr.element.nativeElement.parentElement.classList.add('ferraraclass');
        }

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                layoutService.hideSideModal.next();
                window.scroll(0, 0);
                AnalyticsService.pageView(event.urlAfterRedirects);
                AnalyticsService.sendEvent('pageviewevent', event.urlAfterRedirects);

                if (location.hostname.indexOf('localhost') === -1) {
                    if (location.protocol === 'http:') {
                        window.location.href = location.href.replace('http', 'https');
                    }
                }

                //   ga('set', 'page', event.urlAfterRedirects);
                //   ga('send', 'pageview');
                //   ga('send', 'event', 'pageviewevent', event.urlAfterRedirects);
            }
          });
    }

    ngAfterViewInit(): void {
        $(document).ready(function() {
            $(document).on('focus', 'input', function() {
                $(this).attr('autocomplete', 'off');
                $(this).parent('form').attr('autocomplete', 'off');
            });
        });
        this.iniSlickJs();
    }

    showPopup() {
        this.notificationService.smartMessageBox({
            title: "Your session has expired, you need to login again",
            content: "",
            buttons: '[Ok]'

        }, (ButtonPressed) => {
            if (ButtonPressed == "Ok") {
                this.logout();
                location.reload();
            }
        });
    }

    logout() {
        console.log('>>calling authservice logout');
        if (this.authService.getIsLoggedIn()) {
            this.authService.trackLoginLogout().subscribe(() => {
                this.authService.logout();
            });
        } else {
            this.router.navigate(['auth/login']);
        }
        console.log('<<calling authservice logout');
    }

    ngOnInit() {
        this.msieversion();
        if (location.hostname.indexOf('localhost') === -1) {
            if (location.protocol === 'http:') {
                window.location.href = location.href.replace('http', 'https');
            }
        }

        this.apiservice.unauthorizederror.subscribe(() => {
            this.showPopup();
        });
        this.programSubmittedSubscription = this.programService.programSubmitted.subscribe((id: ProgramId) => {
            console.log(">>new programSubmittedSubscription request", id);
            this.router.navigate([`mycampaigns`]);
        });

        this.programApprovedSubscription = this.programService.programApproved.subscribe((id: ProgramId) => {
            console.log(">>new programApprovedSubscription request", id);
            this.router.navigate([`mycampaigns`]);
        });
    }

    ngOnDestroy() {
        if (this.programApprovedSubscription)
            this.programApprovedSubscription.unsubscribe();

        if (this.programSubmittedSubscription)
            this.programSubmittedSubscription.unsubscribe();
    }

    private iniSlickJs() {
        const htmlScriptElement = document.createElement('script');
        htmlScriptElement.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
        this.elementRef.nativeElement.appendChild(htmlScriptElement);
    }

    msieversion() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            $('body').addClass('ie-browser');
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts